import { render, staticRenderFns } from "./ProductSeries.vue?vue&type=template&id=28264355&"
import script from "./ProductSeries.vue?vue&type=script&lang=js&"
export * from "./ProductSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports